import { Box, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import KycRfiCard from 'components/KycRfi/KycRfiCard';

const ParentRfi = ({ isOpen, onClose, rfiThread, isSubmittedRfi, resourceType }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='xl'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>RFI Thread</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box display='flex' flexDirection='column' gap={2}>
            {rfiThread?.map((rfi) => (
              <KycRfiCard rfi={rfi} isSubmittedRfi={isSubmittedRfi} key={rfi?.id} resourceType={resourceType} />
            ))}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ParentRfi;
